import { app } from '../../../../bootstrap/core';
import { standingOrderFormComponent } from './standingOrderForm.component';
import { StandingOrderFormFields } from './standingOrderForm.constants';

app.component('standingOrderForm', standingOrderFormComponent);
app.value('standingOrderFormFields', StandingOrderFormFields);
